import { ibanValidation } from "@shared-kernel/primary/forms/validations/iban";
import { object, string } from "yup";
import { REQUIRED_FIELD } from "@shared-kernel/primary/forms/constants";
import { siretValidation } from "@shared-kernel/primary/forms/validations/siret";
import { activityRegistrationNumberValidation } from "@shared-kernel/primary/forms/validations/activity-registration-number";
import { addressLookupSchema } from "@shared-kernel/primary/forms/validations/postal-address.schema";
import { EUROPEAN_COUNTRIES } from "@shared-kernel/domain/types/supported-country";
import type { SUPPORTED_COUNTRY } from "@shared-kernel/domain/types/supported-country";
import type { AddressLookup } from "@shared-kernel/domain/types/address-lookup";

export const fullSchema = object({
  name: string().required(REQUIRED_FIELD).max(255),
  legalRepresentativeFirstName: string().required(REQUIRED_FIELD).max(255),
  legalRepresentativeLastName: string().required(REQUIRED_FIELD).max(255),
  iban: ibanValidation(),
  postalAddress: addressLookupSchema,
  addressComplement: string().max(255).defined(),
  country: string().required(REQUIRED_FIELD).oneOf(EUROPEAN_COUNTRIES, "Le pays doit être en Europe"),
  siret: siretValidation(true).defined(),
  activityRegistrationNumber: activityRegistrationNumberValidation(false).defined(),
});

export type ProviderOnboardingFormInputs = {
  name: string;
  legalRepresentativeFirstName: string;
  legalRepresentativeLastName: string;
  iban: string;
  postalAddress: AddressLookup;
  addressComplement: string;
  country: SUPPORTED_COUNTRY;
  siret: string;
  activityRegistrationNumber: string;
};
